<template>
    <div class="app-wrapper" :class="classObj">
        <sidebar class="sidebar-container" />
        <div class="main-container">
            <div class="main-container-box">
                <navbar />
                <tags-view />
           
            </div>
            <app-main />
        </div>
        <customer-service-launcher v-if="showCustomerServiceLauncher" />
    </div>
</template>
<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import Sidebar from './components/Sidebar/index.vue'
import Navbar from './components/Navbar.vue'
import AppMain from './components/AppMain.vue'
import CustomerServiceLauncher from '@/components/customer-service/CustomerServiceLauncher.vue'

import TagsView from './components/TagsView/index.vue'
import { useAppStore } from '@/store/modules/app'
import { useUserStore } from "@/store/modules/user";
import { usePermissionStore } from '@/store/modules/permission'


const appStore = useAppStore()
 const useStore = useUserStore();
const permissionStore = usePermissionStore()
const route = useRoute()
useStore.setUserInfo(() => {
    useStore.setUserDetailInfo()
})
permissionStore.setPermissionInfo()
const classObj = computed(() => ({
  hideSidebar: !appStore.sidebar.opened,
  openSidebar: appStore.sidebar.opened,
}))
const showCustomerServiceLauncher = computed(() => route.meta?.hideCustomerServiceLauncher !== true)
</script>
<style lang="scss" scoped>
.app-wrapper {
    width: 100%;
    height: 100%;
    .sidebar-container {
        position: fixed;
        width: 200px;
        height: inherit;
        -webkit-transition: width .28s;
        transition: width 0.28s;
        background-color: rgb(48, 65, 86);
    }
}
.main-container {
    transition: margin-left .28s;
    margin-left: 200px;
    height: inherit;
}
</style>
